import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { BACKEND_URL } from '../../../../util/api'

const PROCESS_FLOW_URL = BACKEND_URL + '/process/instance/view-flow?processInstanceId='

const FRAME_STYLE = {
    border: 0,
    width: '100%',
    height: '600px',
}

const ProcessFlow = ({ processFlowVisible, processInstanceId }) => {
    if (!processFlowVisible) {
        return null
    }
    return (
        <Row>
            <Column size={12}>
                <iframe
                    style={FRAME_STYLE}
                    src={PROCESS_FLOW_URL + processInstanceId}
                    title="Process Flow"
                />
            </Column>
        </Row>
    )
}

ProcessFlow.propTypes = {
    processFlowVisible: PropTypes.bool.isRequired,
    processInstanceId: PropTypes.string.isRequired,
}


export default ProcessFlow



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/ProcessFlow.js